import { View } from "react-native";
import { Wallet } from "lucide-react-native";

import { SectionTitle, ListRowSkeleton, cardSurface } from "@louise/moon-ui";
import StatusBadge from "../StatusBadge";

export default function MoneySideSection() {
  return (
    <View style={{ marginTop: 24 }}>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          gap: 8,
          marginBottom: 12,
          paddingHorizontal: 2,
        }}
      >
        <SectionTitle icon={Wallet}>The money side</SectionTitle>
        <StatusBadge type="coming-soon" />
      </View>
      <View style={{ ...cardSurface(), padding: 16 }}>
        <ListRowSkeleton showLeadingSquare showSubtitle />
        <ListRowSkeleton showLeadingSquare showSubtitle />
      </View>
    </View>
  );
}
